import React, { Component } from 'react';
import './Component.css';
import Dashboard from './Dashboard/Dashboard.jsx';
import ReadMore from './ReadMore/ReadMore';

class ScaleIndividual extends Component {
	render() {
		let text;

		if (this.props.city === 'auckland') {
			text = <p>Our final illustration invites you to think about the relationship between diversity and opportunity. We encourage you to use the interactive tools at the top of the page to fill in some key characteristics of an imagined person – their sex, age, ethno-cultural background, and immigrant status. As you fill in these characteristics, you will see a set of five indicators that provide an indication of the likely socio-economic situation of that person. The midpoint of each dial represents the average indicator value for the total working-age population.</p>;
		} else if (this.props.city === 'sydney') {
			text = <p>Our final illustration invites you to think about the relationship between diversity and opportunity. We encourage you to use the interactive tools at the top of the page to fill in some key characteristics of an imagined person – their sex, age, ethno-cultural background, and immigrant status. As you fill in these characteristics, you will see a set of five indicators that provide an indication of the likely socio-economic situation of that person. The midpoint of each dial represents the average indicator value for the total working-age population.</p>;
		} else {
			text = <React.Fragment>
				<p>Our final illustration invites you to think about the relationship between diversity and opportunity. We encourage you to use the interactive tools at the top of the page to fill in some key characteristics of an imagined person – their sex, age, ethno-cultural background, and immigrant status. As you fill in these characteristics, you will see a set of six indicators that provide an indication of the likely socio-economic situation of that person. The midpoint of each dial represents the average indicator value for the total working-age population.</p>
				<ReadMore
					content={
						["For example, if you choose to set all the choices to the most general you can then explore the different outcomes across that group. This could be the different cohorts of immigrants (with everything else held constant), or the different categories of immigrants, or the different visible minority groups.",
						"It is particularly interesting to see the changing socio-economic outcomes of refugees over time. Those who have come recently (2010s cohort) face many socio-economic challenges, while those who have been in Vancouver the longest (1980s cohort) have achieved a remarkable degree of economic integration."
						]}
				/>
			</React.Fragment>
		}

		return (
			<div className="Scale-Individual Component" id="individual">
			    <p className="title">Intersections</p>
				<div className="text">
					{text}
				</div>
				<div className="graphic">
					<Dashboard
						city={this.props.city}
						filters={this.props.params.filters}
						update={this.props.update}
					/>
				</div>
			</div>
		);
	}
}

export default ScaleIndividual;


// WEBPACK FOOTER //
// ./src/ScaleIndividual.js